import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'
import { Button } from '@wartek-id/button-v1'

import Header from 'app/BuktiKaryaPage/components/Header'
import { SelectionStepsPraTahap } from './blocks/SelectionSteps'

import type { PMMKSInvitationPageContentType } from './Invitation/ModelBCKSContentPage'

export const SelectionPage = (props: PMMKSInvitationPageContentType) => {
  const { dataContent } = props

  const STATIC_GCS_CDN_PATH = process.env.NEXT_PUBLIC_STATIC_GCS_CDN
  const router = useRouter()

  const previewJuknisURLQuery = {
    title: encodeURI(
      'Salinan akhir Perdirjen Juknis Penugasan Guru Sebagai Kepala Sekolah'
    ),
    docUrl: `${STATIC_GCS_CDN_PATH}/ksps/Juknis%20Seleksi%20Kepala%20Sekolah.pdf`,
  }

  return (
    <div className="relative flex flex-col h-screen max-w-xl mx-auto">
      <Header
        title="Seleksi Kepala Sekolah"
        forceNavigateBack
        variant="large"
      />

      <div className="p-4">
        <Text variant="body">
          Sesuai petunjuk teknis terbaru, seleksi Kepala Sekolah saat ini
          terbuka untuk guru yang sudah mengikuti diklat CKS atau Guru
          Penggerak. Seleksi akan dilakukan di platform Merdeka Mengajar.
        </Text>

        <Link
          passHref
          href={`/bcks/invitation/guide?title=${previewJuknisURLQuery.title}&docUrl=${previewJuknisURLQuery.docUrl}`}
        >
          <Button size="sm" className="mt-2" fullWidth color="white">
            Baca Juknis Terbaru <Icon>chevron_right</Icon>
          </Button>
        </Link>

        <Text variant="heading-sm" className="mt-8">
          {'Kriteria wajib untuk mengikuti seleksi:'}
        </Text>

        <div className="mb-4 mt-2">
          {dataContent.requirementFullfillList.map((requirement, index) => (
            <div key={index} className="flex flex-row items-start px-2">
              <li />
              <Text variant="body-sm">{requirement}</Text>
            </div>
          ))}
        </div>
      </div>

      <Text variant="heading-sm" className="mt-2 p-4">
        {'Tahapan Seleksi'}
      </Text>
      <div className="bg-surface-subdued p-4">
        <SelectionStepsPraTahap />
      </div>

      {process.env.NEXT_PUBLIC_BCKS_QUALIFICATION_CHECK_ENABLED === 'true' && (
        <>
          {/* Qualification Check */}
          <div className="px-4 pt-6 pb-5">
            <Text variant="heading-sm">Cek kualifikasi Anda?</Text>
            <Text variant="body" className="mt-2">
              Cek apakah Anda memenuhi kriteria seleksi Kepala Sekolah. Aksi ini
              hanya bersifat pengecekan, bukan untuk mengikuti seleksi.
            </Text>
            <Button
              className="mt-9"
              fullWidth
              size="lg"
              onClick={() => {
                router.push('/bcks/qualification-check')
              }}
            >
              Cek sekarang
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
